import React, { useEffect, useRef, useState } from "react";
import axios from 'axios';
import { toast } from "react-toastify";

import "../css/style.scss";
import "../css/homepage.css";
import "../css/style.css";
import "../css/animate.min.css";
import "../css/bootstrap.min.css";
import "../css/boxicons.min.css";
import "../css/dark-style.css";
import "../css/dark-style.css.map";
import "../css/dark-style.scss";
import "../css/fancybox.min.css";
import "../css/flaticon.css";
import "../css/magnific-popup.min.css";
import "../css/meanmenu.min.css";
import "../css/responsive.css";
import "../css/responsive.css.map";
import "../css/responsive.scss";
import "../css/style.css.map";

import {
  CheckScoreForScorePage,
  Checkscore,
  Checkuser,
  getGames,
} from "../api/hitapi";

import Navbar from "../component/Navbar.js";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Footer from "../component/Footer";
import gif1 from "../images/gif1.gif";
import gif2 from "../images/giphy.webp";
import coins from "../images/coins.gif";
import gemerimg from "../images/just_gamers_img.png";
import line from "../images/download.png";
import spinimg from "../images/Spin.png";
import sudoku from "../images/sudoku.png";
import spintext from "../images/spin-text.png";
import Cookies from "js-cookie";
import "bootstrap/dist/css/bootstrap.min.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import GameScene from "./GameScene";

// ===== HELPER: BUILD GAME URL =====
const buildGameUrl = (gameUrl, gameId, ani) => {
  const baseUrl = gameUrl.trim().replace(/\/$/, "").replace(/\s+/g, "");

  if (gameId === 12) {
    return `${baseUrl}/game/levels?msisdn=${ani}`;
  } else if (gameId === 9 || gameId === 10) {
    return `${baseUrl}/?msisdn=${ani}`;
  }

  return null;
};

const Homepage = () => {
  const owlCarouselRef = useRef(null);

  const [list, setList] = useState([]);
  const [image, setImage] = useState([]);
  const [score, setScore] = useState("");
  const [gifData, setGifData] = useState([]);
  const [games, setGames] = useState([]);
  const [categoryDisplay, setCategoryDisplay] = useState("block");
  const [modalShow, setModalShow] = useState(false);
  const [groupedGames, setGroupedGames] = useState({});

  const navigate = useNavigate();

  // ===== GROUP GAMES BY CATEGORY =====
  const groupGamesByCategory = (games) => {
    const groupedGames = {};
    const seenIds = new Set();
    games.forEach((game) => {
      const category = game.gameCategory;
      if (game.id !== 15 && !seenIds.has(game.id)) {
        seenIds.add(game.id);
        if (!groupedGames[category]) {
          groupedGames[category] = [];
        }
        groupedGames[category].push(game);
      }
    });
    return groupedGames;
  };

  useEffect(() => {
    try {
      getGames().then((response) => {
        const gamesList = response.games || [];
        const gifsList = response.gifs || [];

        setList(gamesList);
        setImage(gamesList);
        setGifData(gifsList);

        if (owlCarouselRef.current) {
          window.dispatchEvent(new Event("resize"));
        }

        ScoreMethod();

        const gamesGrouped = groupGamesByCategory(gamesList);
        setGroupedGames(gamesGrouped);
      });
    } catch {
      console.log("Exception");
    }
  }, []);

  // ===== CAROUSEL OPTIONS =====
  const options = {
    center: false,
    items: 4,
    loop: true,
    margin: 5,
    stagePadding: 15,
    autoplay: true,
    autoPlaySpeed: 300,
    autoplayTimeout: 1000,
    responsive: {
      0: { items: 2 },
      400: { items: 2 },
      600: { items: 3 },
      700: { items: 3 },
      1000: { items: 4 },
    },
  };

  const OwlCarouselOptions = {
    items: 3,
    loop: true,
    margin: 5,
    nav: true,
    autoplay: true,
    autoPlaySpeed: 1000,
    autoplayTimeout: 1000,
    slideTransition: "linear",
    responsive: {
      0: { items: 1 },
      400: { items: 1 },
      600: { items: 3 },
      700: { items: 3 },
      1000: { items: 3 },
    },
  };

  // ===== AUTH CHECK =====
  const ScoreMethod = () => {
    const ani = Cookies.get("ani");
    Checkuser(ani)
      .then((response) => {
        console.log("check-access:", response);
        if (response.data !== true) {
          navigate("/subscribe");
        }
      })
      .catch((err) => {
        console.log("ScoreMethod error:", err);
      });
  };

  const CheckUserScore = () => {
    const ani = Cookies.get("ani");
    CheckScoreForScorePage(ani).then((response) => {
      setScore(response.data.Score);
      Cookies.set("Score", response.data.Score);
    });
  };

  // ===== OPEN GAME — same tab, browser back returns to /home cleanly =====
  // FIX: We push the current /home path into history BEFORE navigating away,
  // so that when the user hits Back in the game browser, they return to /home
  // without any hash (#!!) appended.
  const navigateToGame = (url) => {
    if (!url) return;
    // Replace current history entry with /home (strips any stale hash),
    // then push the game URL so Back lands on clean /home.
    window.history.replaceState(null, "", window.location.pathname);
    window.location.href = url;
  };

  const showimage = (id) => {
    const ani = Cookies.get("ani");
    const item = gifData.find((g) => g.id === id);
    if (!item) return;
    const url = buildGameUrl(item.gameUrl, item.id, ani) || item.gameUrl;
    navigateToGame(url);
  };

  const checkUserPoint = (gameUrl, gameId) => {
    navigateToGame(gameUrl);
  };

  const redirectToGame = (gameUrl, gameId) => {
    navigateToGame(gameUrl);
  };

  // ===== FILTER =====
  const Filter = (name) => {
    setList(
      image.filter((item) => {
        if (name === "ALL") return item.rating;
        return item.rating == name;
      })
    );
  };

  // ===== MODAL =====
  const handleModalShow = (category) => {
    setGames(image.filter((item) => item.gameCategory === category));
    setModalShow(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  return (
    <>
      <Navbar />

      {/* Category Modal */}
      <Modal centered show={modalShow} onHide={handleModalClose}>
        <div className="c-main-box">
          <Modal.Body>
            <section className="player-details-area">
              <div className="container">
                <div className="streams-list score-change">
                  <div className="row vt-show-game">
                    {games.length > 0 &&
                      games.map((item, index) => (
                        <div key={index} className="col-lg-12 col-md-12">
                          <div
                            className="single-live-stream-item"
                            onClick={() =>
                              redirectToGame(item.gameUrl, item.id)
                            }
                          >
                            <img src={item.imageUrl} alt={item.gameName} />
                            <div className="content">
                              <h3 style={{ color: "white" }}>
                                {item.gameName}
                              </h3>
                            </div>
                            {/* FIX: e.preventDefault() stops #!! being added to history */}
                            <a
                              href="#"
                              className="video-btn"
                              onClick={(e) => e.preventDefault()}
                            >
                              <i className="flaticon-play-button" />
                            </a>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </section>
          </Modal.Body>
        </div>
      </Modal>

      {/* Search Overlay */}
      <div className="search-overlay">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="search-overlay-layer" />
            <div className="search-overlay-layer" />
            <div className="search-overlay-layer" />
            <div className="search-overlay-close">
              <span className="search-overlay-close-line" />
              <span className="search-overlay-close-line" />
            </div>
            <div className="search-overlay-form">
              <form>
                <input
                  type="text"
                  className="input-search"
                  placeholder="Search here..."
                />
                <button type="submit">
                  <i className="flaticon-search-1" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Main Banner */}
      <div
        className="main-banner jarallax"
        data-jarallax='{"speed": 0.3}'
        id={localStorage.getItem("id")}
      >
        <div className="container pt-5">
          <div className="main-banner-content">
            <span
              className="sub-title wow animate__animated animate__fadeInLeft"
              data-wow-delay="00ms"
              data-wow-duration="1000ms"
            >
              <div className="loader">
                <span>S</span>
                <span>p</span>
                <span>i</span>
                <span>n</span>
                <span>-</span>
                <span>E</span>
                <span>a</span>
                <span>r</span>
                <span>n</span>
                <span>-</span>
                <span>R</span>
                <span>e</span>
                <span>d</span>
                <span>e</span>
                <span>e</span>
                <span>m</span>
              </div>
            </span>

            <div
              className="logo wow animate__animated animate__fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1000ms"
            >
              <h6
                className="wow animate__animated animate__fadeInRight"
                data-wow-delay="00ms"
                data-wow-duration="1000ms"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="text-animation">
                  <div className="text-wrapper">
                    <h2>
                      {localStorage.getItem("GameName")}
                      <br />
                      {localStorage.getItem("reward")}
                    </h2>
                    <h2>
                      {localStorage.getItem("GameName")}
                      <br />
                      {localStorage.getItem("reward")}
                    </h2>
                  </div>
                </div>
              </h6>
            </div>
          </div>
        </div>
      </div>

      {/* GameScene + GIF Carousel */}
      <div>
        <div
          style={{
            backgroundImage: `url(${gif1}), url(${gif2})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top right, left top",
          }}
        >
          <div className="col d-flex justify-content-center">
            <GameScene />
          </div>
        </div>

        {/* GIF Carousel — clicks open game in same browser tab */}
        {gifData.length > 0 && (
          <div className="container">
            <div className="row align-correct px-2">
              <div
                className="row d-flex justify-content-center gif-row"
                style={{
                  backgroundImage: `url(${gif1}), url(${gif2})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "top right, left top",
                }}
              >
                <OwlCarousel
                  ref={owlCarouselRef}
                  className="story owl-carousel owl-theme"
                  {...{
                    ...options,
                    loop: gifData.length > (options.items || 4),
                  }}
                >
                  {gifData.map((items) => (
                    <div key={items.id} className="item">
                      <div className="mb-3 px-0">
                        {/*
                          FIX: button onClick calls showimage() which uses
                          navigateToGame() → replaceState cleans /home,
                          then location.href goes to the game.
                          Browser Back returns to clean /home, no re-render below.
                        */}
                        <button
                          className="radius"
                          onClick={() => showimage(items.id)}
                          style={{
                            background: "transparent",
                            border: "none",
                            backgroundImage: `url(${coins})`,
                          }}
                        >
                          <img
                            src={items.gameGif}
                            alt={items.gameName || "game"}
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Top Categories */}
      <div className="correction1" style={{ color: "white" }}>
        <div className="container pb-5">
          <div className="streams-list">
            <h3>Top Categories Games</h3>
            <div className="row">
              {Object.keys(groupedGames)
                .slice(0, 6)
                .map((category) => {
                  const firstGame = groupedGames[category][0];
                  return (
                    <div
                      key={category}
                      className="col-lg-4 col-6 col"
                      style={{ display: `${categoryDisplay}` }}
                    >
                      <div
                        className="single-live-stream-item"
                        onClick={() => handleModalShow(category)}
                      >
                        <img
                          src={firstGame.imageUrl}
                          alt={category}
                          style={{ borderRadius: "10% !important" }}
                        />
                        <div className="content">
                          <h3>{category}</h3>
                        </div>
                        {/* FIX: preventDefault stops hash being pushed to history */}
                        <a
                          href="#"
                          className="link-btn"
                          onClick={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="btn-box d-flex justify-content-center">
            <Link
              to="/Allcategory"
              className="default-btn"
              style={{ display: `${categoryDisplay}` }}
            >
              See All
            </Link>
          </div>
        </div>
      </div>

      {/* Just Gamers Section */}
      <section className="just-gamers-img">
        <div className="container">
          <div className="just-game-inner">
            <div className="g-inner-box3">
              <img className="g-image1" src={gemerimg} alt="gemerimg" />
              <div className="line-img">
                <img className="g-image2" src={line} alt="line" />
                <img className="g-image3" src={spinimg} alt="spinimg" />
                <img className="spin-text-img" src={spintext} alt="spintext" />
              </div>
            </div>
            <div className="g-inner-box2">
              <img className="sudoku-img" src={sudoku} alt="sudoku" />
            </div>
          </div>
        </div>
      </section>

      {/* Games By Category Carousels */}
      <div>
        {Object.keys(groupedGames).map((category, index) => {
          const categoryGames = groupedGames[category];
          const visibleItems = OwlCarouselOptions.items || 3;
          return (
            <section key={index} className="top-c-slider">
              <div className="container">
                <h2>{category}</h2>
                <div className="top-c-slider-inner">
                  <div className="carousel-wrap">
                    <div className="category">
                      <OwlCarousel
                        className="story owl-carousel owl-theme"
                        {...{
                          ...OwlCarouselOptions,
                          loop: categoryGames.length > visibleItems,
                        }}
                      >
                        {categoryGames.map((gameItem) => (
                          <div
                            key={gameItem.id}
                            className="item category-inner"
                          >
                            <div className="category-box">
                              <img
                                src={gameItem.imageUrl}
                                onClick={() =>
                                  checkUserPoint(gameItem.gameUrl, gameItem.id)
                                }
                                alt={gameItem.gameName || "game"}
                              />
                            </div>
                          </div>
                        ))}
                      </OwlCarousel>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          );
        })}
      </div>

      {/* Top Rated Filter */}
      <section
        className="live-stream-area ptb-100 jarallax"
        data-jarallax='{"speed": 0.3}'
      >
        <div className="container">
          <div className="section-title">
            <span className="sub-title">Top Rated Games</span>
            <h2 style={{ color: "white" }}>Filter By Rating</h2>
          </div>
          <div className="live-stream-tabs">
            <ul className="nav nav-tabs mb-4" id="myTab" role="tablist">
              {[
                { label: "ALL", value: "ALL" },
                { label: "4.5", value: 4.5 },
                { label: "4.3", value: 4.3 },
                { label: "4.7", value: 4.7 },
                { label: "4.2", value: 4.2 },
              ].map((tab) => (
                <li key={tab.label} className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#"
                    role="tab"
                    onClick={(e) => {
                      e.preventDefault();
                      Filter(tab.value);
                    }}
                  >
                    {tab.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="tab-content" style={{ color: "white" }}>
              <div className="row">
                {list.map((item, index) => (
                  <div
                    key={index}
                    className="col-lg-6 col-md-6 col-sm-6 col-6 pb-4"
                  >
                    <div className="single-live-stream-box">
                      <img src={item.imageUrl} alt={item.gameName} />
                      <div className="content">
                        <h3>
                          {item.gameName}
                          <i className="flaticon-play" />
                        </h3>
                        <h3 className="rating1">{item.rating}</h3>
                      </div>
                      <span
                        onClick={() => checkUserPoint(item.gameUrl, item.id)}
                        className="link-btn"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="btn-box d-flex justify-content-center">
              <Link to="/Allimages" className="default-btn">
                See All
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Homepage;

